define("shared/components/shared/post/secondary/hashtag-suggestions/auto", ["exports", "@ember/component", "@ember/runloop", "@ember/service", "@glimmer/component", "@glimmer/tracking", "lodash", "shared/utils/get-hashtags", "@ember/template-factory"], function (_exports, _component, _runloop, _service, _component2, _tracking, _lodash, _getHashtags, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _setSideModalLoading;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"lodash",0,"shared/utils/get-hashtags",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="u--p__lr__lg u--m__0" {{track "clicked-beta-caption-hashtag-suggestions" "click"}}>
    <p>
      {{t "hashtag_suggestions.auto.description"}}
    </p>
  </div>
  
  {{#if this.showCalculatingAnimation}}
    <Shared::Ui::CalculatingState @text={{t "hashtag_suggestions.loading"}} class="u--text--uppercase" />
  {{else if this.showCaptionHashtags}}
    <hr class="u--m__tb__0" />
    <Shared::Post::Secondary::HashtagSuggestions::Table
      @selectHashtag={{@selectHashtag}}
      @selectedHashtags={{@selectedHashtags}}
      @suggestedHashtags={{this.uniqueCaptionHashtags}}
    />
  {{else if this.showNoCaptionState}}
    <Shared::Post::Secondary::HashtagSuggestions::NoCaption />
  {{else if this.isError}}
    <Shared::Post::Secondary::HashtagSuggestions::Error @hashtagQuery={{null}} @isSearch={{false}} />
  {{else if this.showEmptyState}}
    <Shared::Post::Secondary::HashtagSuggestions::Empty
      @isSearch={{false}}
      @suggestedHashtags={{@uniqueCaptionHashtags}}
    />
  {{/if}}
  */
  {
    "id": "6BNTL9MR",
    "block": "[[[11,0],[24,0,\"u--p__lr__lg u--m__0\"],[4,[38,0],[\"clicked-beta-caption-hashtag-suggestions\",\"click\"],null],[12],[1,\"\\n  \"],[10,2],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"hashtag_suggestions.auto.description\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showCalculatingAnimation\"]],[[[1,\"  \"],[8,[39,3],[[24,0,\"u--text--uppercase\"]],[[\"@text\"],[[28,[37,1],[\"hashtag_suggestions.loading\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showCaptionHashtags\"]],[[[1,\"  \"],[10,\"hr\"],[14,0,\"u--m__tb__0\"],[12],[13],[1,\"\\n  \"],[8,[39,4],null,[[\"@selectHashtag\",\"@selectedHashtags\",\"@suggestedHashtags\"],[[30,1],[30,2],[30,0,[\"uniqueCaptionHashtags\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showNoCaptionState\"]],[[[1,\"  \"],[8,[39,5],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isError\"]],[[[1,\"  \"],[8,[39,6],null,[[\"@hashtagQuery\",\"@isSearch\"],[null,false]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showEmptyState\"]],[[[1,\"  \"],[8,[39,7],null,[[\"@isSearch\",\"@suggestedHashtags\"],[false,[30,3]]],null],[1,\"\\n\"]],[]],null]],[]]]],[]]]],[]]]],[]]]],[\"@selectHashtag\",\"@selectedHashtags\",\"@uniqueCaptionHashtags\"],false,[\"track\",\"t\",\"if\",\"shared/ui/calculating-state\",\"shared/post/secondary/hashtag-suggestions/table\",\"shared/post/secondary/hashtag-suggestions/no-caption\",\"shared/post/secondary/hashtag-suggestions/error\",\"shared/post/secondary/hashtag-suggestions/empty\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/auto.hbs",
    "isStrictMode": false
  });
  let AutoComponent = _exports.default = (_dec = (0, _service.inject)('schedule/caption-hashtags'), (_class = (_setSideModalLoading = /*#__PURE__*/new WeakSet(), class AutoComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _classPrivateMethodInitSpec(this, _setSideModalLoading);
      _initializerDefineProperty(this, "scheduleCaptionHashtags", _descriptor, this);
      _initializerDefineProperty(this, "showSideModalLoading", _descriptor2, this);
      _classPrivateMethodGet(this, _setSideModalLoading, _setSideModalLoading2).call(this);
    }
    get uniqueCaptionHashtags() {
      return this.args.captionHashtags.filter(_ref => {
        let {
          hashtag
        } = _ref;
        return !this.usedHashtags.includes(hashtag);
      });
    }
    get usedHashtags() {
      return (0, _getHashtags.default)(this.args.currentText);
    }
    get showCalculatingAnimation() {
      return this.showSideModalLoading || this.scheduleCaptionHashtags.isLoading;
    }
    get showCaptionHashtags() {
      return !this.showCalculatingAnimation && !this.showNoCaptionState && !this.showEmptyState && !this.isError;
    }
    get showNoCaptionState() {
      return !this.args.currentText.split(' ').filter(word => word !== '').length;
    }
    get showEmptyState() {
      return (0, _lodash.isEmpty)(this.uniqueCaptionHashtags);
    }
    get isError() {
      return this.scheduleCaptionHashtags.error !== null;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "scheduleCaptionHashtags", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showSideModalLoading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  })), _class));
  function _setSideModalLoading2() {
    this.showSideModalLoading = true;
    (0, _runloop.later)(() => {
      this.showSideModalLoading = false;
    }, 300);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AutoComponent);
});